import Certificate from './certificate';

const templates = [
  {
    id: 'DEFAULT_TRANSCRIPT',
    label: 'Document',
    template: Certificate,
  },
];

export default templates;
